import { CtStockItem } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    title: {
      field: 'title',
      label: 'Title',
      validator: () => true,
      type: 'string',
      required: true
    },
    sku: {
      field: 'sku',
      label: 'Stock Keeping Unit (sku)',
      validator: () => true,
      type: 'string',
      required: true
    },
    ean: {
      field: 'ean',
      label: 'EAN',
      validator: () => true,
      type: 'array',
      required: false
    },
    weight: {
      field: 'weight',
      label: 'Weight',
      validator: () => true,
      type: 'number',
      default: 0,
      required: true
    },
    categories: {
      field: 'categories',
      label: 'Stock Item Categories',
      validator: () => true,
      type: 'link-list',
      required: false
    },
    packing: {
      field: 'packing',
      label: 'Packing',
      validator: () => true,
      contentType: 'packing',
      type: 'link-list',
      default: [],
      required: false
    },
    props: {
      field: 'props',
      label: 'Item Properties',
      validator: () => true,
      type: 'json',
      default: {},
      required: false
    },
    meta: {
      field: 'meta',
      label: 'Meta',
      validator: () => true,
      type: 'json',
      required: false
    },
    // vat: {
    //   field: 'vat',
    //   label: 'Vat',
    //   validator: () => true,
    //   type: 'string',
    //   required: false
    // },
    dimensions: {
      field: 'dimensions',
      label: 'Dimensions',
      validator: () => true,
      type: 'json',
      required: false,
      default: {
        width: 0,
        height: 0,
        depth: 0
      }
    },
    brand: {
      field: 'brand',
      label: 'Brand',
      validator: () => true,
      type: 'string',
      required: false
    },
    batch: {
      field: 'batch',
      label: 'Sold in batches of',
      validator: () => true,
      type: 'string',
      required: false
    },
    minimum_order_quantity: {
      field: 'minimum_order_quantity',
      label: 'Minimum Order Quantity (number of batches)',
      validator: () => true,
      type: 'string',
      required: false
    },
    producer: {
      field: 'producer',
      label: 'Producer',
      validator: () => true,
      type: 'string',
      required: false
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}
const options = {
  // import: true
}

export default ContentModule<CtStockItem>(
  ContentType.StockItem, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions,
  options)
